import moment from 'moment';

export const getMinDate = (veranstaltung) => moment(veranstaltung.beginn).startOf("day").valueOf()
export const isVeranstaltungsBeginnInZukunft = (veranstaltung) => getMinDate(veranstaltung) > moment().startOf("day").valueOf()
/**
 * Uhrzeitgenau - und darin der Unterschied zum Geschwister eine Zeile darueber, das den **Tag**
 * meint. Beide werden gebraucht, und zwar fuer Verschiedenes:
 *
 * - Der **Tag** entscheidet ueber das **Erfassen**. Am Einlass steht die Schlange vor dem Beginn,
 *   und dass die App da schon arbeitet, ist richtig.
 * - Die **Uhrzeit** entscheidet ueber das **Melden**. Eine Meldung vor dem Beginn ist eine
 *   Planung, keine Tatsache; die Kammern weisen solche Punkte zurueck - und zwar stumm, denn der
 *   EIV nimmt sie mit 200 an und die App streicht die Teilnahme daraufhin aus der Warteschlange.
 *
 * Ohne `beginn` wird **nicht** gesperrt: eine fehlende Angabe darf die App nicht lahmlegen.
 * Exakt zur Beginnsekunde ist Melden erlaubt (`>`, nicht `>=`).
 */
export const istVorVeranstaltungsbeginn = (veranstaltung, jetzt = Date.now()) =>
	Boolean(veranstaltung && veranstaltung.beginn) && moment(veranstaltung.beginn).valueOf() > jetzt
export const getMaxDate = (veranstaltung) => {
	const maxDate = moment(veranstaltung.ende).startOf("day").valueOf();
	const today = moment().startOf("day").valueOf();
	return today > maxDate?maxDate:today
}
const KATEGORIEN_MIT_ABWEICHENDEN_TEILNAHMEDATUM = ["D", "I", "H"];
export const istBeginnUndEndeDatumGleich = (veranstaltung) => getMinDate(veranstaltung) === getMaxDate(veranstaltung)
export const isShowTeilnahmedatum = (veranstaltung) => 
	!istBeginnUndEndeDatumGleich(veranstaltung) && KATEGORIEN_MIT_ABWEICHENDEN_TEILNAHMEDATUM.indexOf(veranstaltung.kategorie) >= 0
export const isPreventTeilnahmedatumMeldung = (veranstaltung) => 
	istBeginnUndEndeDatumGleich(veranstaltung) || KATEGORIEN_MIT_ABWEICHENDEN_TEILNAHMEDATUM.indexOf(veranstaltung.kategorie) < 0
